module.exports = __webpack_public_path__ + "84f4172db0f8ee007d63c27cc8095931.svg";